<script setup lang="ts">
import './assets/style.scss'
import { computed, type PropType } from 'vue'
import { InventObject } from '@/widgets'
import { VIcons } from '@/shared/ui'
import { useHelpers } from '@/shared/lib'

const props = defineProps({
  item: {
    type: Object as PropType<InventObject>,
    required: true,
  },
  selected: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
  small: {
    type: Boolean,
    default: false,
  },
  dot: {
    type: Boolean,
    default: false,
  },
})

const { getColorForBackground } = useHelpers()
const emits = defineEmits(['selected'])

const itemData = computed(() => {
  const bgColor = props.item.getStyles().fill.slice(0, 7)

  return {
    id: props.item.getId(),
    icon: props.item.getType().icon,
    bgColor: bgColor,
    color: getColorForBackground(bgColor),
  }
})

/**
 * Функция обработки выбора элемента
 * @param id
 */
const clickHandler = (id: number) => {
  emits('selected', [id])
}
</script>

<template>
  <div
    class="v-map-invent-info-marker"
    :class="{
      'v-map-invent-info-marker_disable': selected.length && !selected.includes(itemData.id),
      'v-map-invent-info-marker_small': small && !dot,
      'v-map-invent-info-marker_dot': dot,
    }"
    @click="clickHandler(itemData.id)"
  >
    <template v-if="!dot">
      <span
        :style="{ backgroundColor: itemData.bgColor, color: itemData.color }"
      >
        <VIcons :type="itemData.icon" />
      </span>
    </template>
    <template v-else>
      <span :style="{ backgroundColor: itemData.bgColor }" />
    </template>
  </div>
</template>
